import View from './view'

const ConnectAllProjects = View
export default ConnectAllProjects